export default "<div #dvc></div>";